
export const TitleType = [
  // Publico
  { icon: "", text: "Inicio", path: "/home" },
  { icon: "", text: "Mi Perfil", path: "/mi-perfil" },
  // Administracion
  { icon: "", text: "Empresa", path: "/empresas" },
  { icon: "", text: "Usuarios", path: "/usuarios" },
  { icon: "", text: "Cuentas MP", path: "/mercado_pago" },
  // Proyectos
  { icon: "", text: "Proyectos", path: "/proyectos"},
  { icon: "", text: "Rendición", path: "/proyectos/rendicion/proyecto" },  
  { icon: "", text: "Rendiciones", path: "/proyectos/rendiciones" },  
  // Eventos
  { icon: "", text: "Eventos", path: "/eventos"},  
  { icon: "", text: "Alta Eventos", path: "/eventos/alta-eventos"},  
  { icon: "", text: "Configuración Evento", path: "/eventos/configuracion-eventos"},
  { icon: "", text: "Resumen Pagos", path: "/eventos/resumen-pagos" },
  { icon: "", text: "Integrantes Evento", path: "/eventos/integrantes-evento"},
  { icon: "", text: "Papelera", path: "/eventos/papelera-evento"},
  { icon: "", text: "Acreditación", path: "/eventos/acreditacion"},
  { icon: "", text: "Acreditación", path: "/eventos/acreditar-integrante"},
  { icon: "", text: "Grupos", path: "/eventos/grupos"},
  { icon: "", text: "Integrantes Grupo", path: "/eventos/grupos/integrantes-grupo"},
  // Inscripciones
  { icon: "", text: "Búsqueda de Inscriptos", path: "/inscripciones" }, 
  { icon: "", text: "Encuesta Médica", path: "/inscripciones/encuesta-medica" },
  // Facturas
  { icon: "", text: "Facturas Emitidas", path: "/facturas"},
  // Teams
  { icon: "", text: "Teams", path: "/teams"},
  { icon: "", text: "Nuevo Team", path: "/teams/nuevo-team"},
  { icon: "", text: "Edición Team", path: "/teams/edicion-team"},
  { icon: "", text: "Integrantes Team", path: "/teams/integrantes-team"},
  // Acreticacion 
  { icon: "", text: "Acreditación", path: "/acreditacion"}
];
